// API 文档字段名直接作为 React key；合并时出现同名字段会导致重复展示和规则丢失，因此在定义阶段立即失败。
export const defineUniqueFields = (schemaName, fields) => {
  if (!Array.isArray(fields)) {
    throw new TypeError(`${schemaName} fields must be an array`);
  }

  const names = new Set();
  fields.forEach((field, index) => {
    if (!field || typeof field.name !== 'string' || field.name.trim() === '') {
      throw new TypeError(`${schemaName} field at index ${index} must have a name`);
    }
    if (names.has(field.name)) {
      throw new Error(`${schemaName} contains duplicate field: ${field.name}`);
    }
    names.add(field.name);
  });
  return fields;
};